import React from 'react'
import MatAccordionSummary from '@material-ui/core/AccordionSummary'
import { ReactComponent as ExpandIcon } from 'assets/icons/dropdown.svg'

export function AccordionSummary ({ classes, children }) {
  return (
    <MatAccordionSummary
      classes={classes}
      expandIcon={<ExpandIcon/>}
    >
      {children}
    </MatAccordionSummary>
  )
}
